/** @format */

import styled from '@emotion/styled';

export const StyledDialogueArea = styled.aside`
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  z-index: 1001;
`;
